import { render, staticRenderFns } from "./LeadInCharge.vue?vue&type=template&id=4ec73caa"
import script from "./LeadInCharge.vue?vue&type=script&lang=js"
export * from "./LeadInCharge.vue?vue&type=script&lang=js"
import style0 from "./LeadInCharge.vue?vue&type=style&index=0&id=4ec73caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports